import { render, staticRenderFns } from "./LoadingStation.vue?vue&type=template&id=245b8362&scoped=true&"
import script from "./LoadingStation.vue?vue&type=script&lang=ts&"
export * from "./LoadingStation.vue?vue&type=script&lang=ts&"
import style0 from "./LoadingStation.vue?vue&type=style&index=0&id=245b8362&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_m6jvttnwtqqy6l4pi5vsxiehsy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245b8362",
  null
  
)

export default component.exports